import styles from "./FunnelStepper.module.css";
import CheckIcon from '@mui/icons-material/Check';
import React from "react";

type Props = {
    funnelSteps: FunnelStep[];
    currentStepIndex: number;
    onClick: (stepIndex: number) => void;
};

const FunnelStepper: React.FC<Props> = ({
    funnelSteps,
    currentStepIndex,
    onClick
}) => {

    const stepperSteps = funnelSteps.map((step, index) => {
        let stepStateClassName, stepClickableClassName;
        let clickable = false;
        let stepText: string | React.ReactNode = `${index + 1}`;

        switch (true) {
            case index < currentStepIndex:
                stepStateClassName = styles.completed;
                stepClickableClassName = styles.clickable;
                clickable = true;
                stepText = <CheckIcon />
                break;
            case index === currentStepIndex:
                stepStateClassName = styles.active;
                stepClickableClassName = styles.disabled;
                break;
            case index > currentStepIndex:
                stepStateClassName = styles.upcoming;
                stepClickableClassName = styles.disabled;
                break;
        }

        const handleOnClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            if (clickable && event.currentTarget.dataset.stepIndex != undefined) {
                onClick(parseInt(event.currentTarget.dataset.stepIndex));
                return;
            }
        }

        return (
            <div
                key={step.id}
                data-step-index={index}
                className={`${styles.stepIndicator} ${stepStateClassName} ${stepClickableClassName}`}
                title={step.title}
                onClick={handleOnClick}
            >
                <span className={styles.stepNumber}>{stepText}</span>
                <span className={styles.stepTitle}>{step.title}</span>
            </div>
        );
    });

    return (
        <div className={styles.stepIndicators}>
            {stepperSteps}
        </div>
    );
}

export default FunnelStepper;